import { Chart, useChart } from "@chakra-ui/charts";
import { Card, Text, Flex, IconButton, Box } from "@chakra-ui/react";
import { Tooltip as ChakraTooltip } from "@/components/ui/tooltip";
import { MdInfoOutline } from "react-icons/md";
import { CartesianGrid, Bar, BarChart, XAxis, YAxis } from "recharts";

import { IObservationStats } from "@/types/data";
import { HEALTH_ISSUES } from "@/pages/racks/RackObservation/health_issues";

interface IBarChart {
  title: string;
  info?: string;
  data: IObservationStats[];
}

function BarChartBox({ title, info, data }: IBarChart) {
  const total_fragments = data.reduce((acc, i) => acc + i.fragments_count, 0);
  const issues = HEALTH_ISSUES.map((i) => ({
    name: i.label,
    value: Number(
      (
        data.reduce((acc, d) => acc + Number(d[i.value as keyof IObservationStats]), 0) / total_fragments
      ).toPrecision(2)
    )
  })).sort((a, b) => b.value - a.value);
  const chart = useChart({
    data: issues.slice(0, 5),
    series: [{ name: "value", color: "blue.500" }]}
  );

  return (
    <Card.Root size="sm">
      <Card.Body>
        <Flex justifyContent="space-between" alignItems="center" mb="6">
          <Text textAlign="left" fontWeight="600">{ title }</Text>
          {info?.length && (
            <ChakraTooltip contentProps={{ color: "white" }} content={info}>
              <IconButton variant="ghost" size="xs" opacity="0.5">
                <MdInfoOutline />
              </IconButton>
            </ChakraTooltip>)}
        </Flex>
        <Box>
          <Chart.Root chart={chart} height="13.25rem">
            <BarChart data={chart.data} layout="vertical" responsive>
              <CartesianGrid stroke={chart.color("border.muted")} horizontal={false} />
              <XAxis
                axisLine={false}
                tickLine={false}
                tickMargin={10}
                type="number"
                domain={[0, "dataMax + 1"]}
                unit="%"
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                type="category"
                dataKey={chart.key("name")}
              />
              {chart.series.map((item) => (
                <Bar
                  key={item.name}
                  isAnimationActive={false}
                  dataKey={chart.key(item.name)}
                  fill={chart.color(item.color)}
                  type="monotone"
                />
              ))}
            </BarChart>
          </Chart.Root>
        </Box>
      </Card.Body>
    </Card.Root>
  );
}

export default BarChartBox;
